import { render } from "./Index.vue?vue&type=template&id=ddaac8b6"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Teams/New/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddaac8b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddaac8b6', __exports__)) {
    api.reload('ddaac8b6', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=ddaac8b6", () => {
    api.rerender('ddaac8b6', render)
  })

}


export default __exports__